import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "card" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "card-header" }, [
  /*#__PURE__*/_createElementVNode("h5", { class: "card-title" }, "Permissions")
], -1)
const _hoisted_4 = { class: "card-body" }
const _hoisted_5 = { class: "nav nav-pills nav-pills-custom position-relative mx-0 mb-9" }
const _hoisted_6 = ["onClick"]
const _hoisted_7 = { class: "nav-text text-gray-800 fw-bolder fs-6 mb-3" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("span", { class: "bullet-custom position-absolute z-index-2 bottom-0 w-100 h-4px bg-primary rounded" }, null, -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("span", { class: "position-absolute z-index-1 bottom-0 w-100 h-4px bg-light rounded" }, null, -1)
const _hoisted_10 = { class: "card my-7" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("div", { class: "card-header" }, [
  /*#__PURE__*/_createElementVNode("h5", { class: "card-title" }, "Current permissions")
], -1)
const _hoisted_12 = { class: "card-body" }
const _hoisted_13 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Simple = _resolveComponent("Simple")!
  const _component_Advance = _resolveComponent("Advance")!
  const _component_Keys = _resolveComponent("Keys")!
  const _component_Loading = _resolveComponent("Loading")!

  return (!_ctx.loading)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _hoisted_3,
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("ul", _hoisted_5, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tabs, (tab, index) => {
                return (_openBlock(), _createElementBlock("li", {
                  key: index,
                  class: "nav-item mx-0 p-0"
                }, [
                  _createElementVNode("a", {
                    class: _normalizeClass(["nav-link d-flex justify-content-center w-100 border-0 h-100 cursor-pointer", {'active':_ctx.selectedTab == tab.value}]),
                    "data-bs-toggle": "pill",
                    onClick: ($event: any) => (_ctx.selectedTab = tab.value)
                  }, [
                    _createElementVNode("span", _hoisted_7, _toDisplayString(tab.title), 1),
                    _hoisted_8
                  ], 10, _hoisted_6)
                ]))
              }), 128)),
              _hoisted_9
            ]),
            _createElementVNode("div", null, [
              (_ctx.selectedTab == 'simple')
                ? (_openBlock(), _createBlock(_component_Simple, {
                    key: 0,
                    account: _ctx.account
                  }, null, 8, ["account"]))
                : _createCommentVNode("", true),
              (_ctx.selectedTab == 'advance')
                ? (_openBlock(), _createBlock(_component_Advance, {
                    key: 1,
                    account: _ctx.account
                  }, null, 8, ["account"]))
                : _createCommentVNode("", true)
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_10, [
          _hoisted_11,
          _createElementVNode("div", _hoisted_12, [
            _createVNode(_component_Keys, { account: _ctx.account }, null, 8, ["account"])
          ])
        ])
      ]))
    : (_openBlock(), _createElementBlock("div", _hoisted_13, [
        _createVNode(_component_Loading)
      ]))
}